var $, Accordion, AnimateIndex, AnimateTitle, CarouselBanner, CarouselCharacter, CarouselMovie, CastStaff, Character, Footer, Header, Index, Loading, Media, Modal, News, ReplaceImg, ReplaceYoutube, Video, _, _device, _sp, _ua, easeljs, preloadjs,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

$ = window.jQuery = require('./lib/jquery.min');

require('./lib/jquery.easing.min');

require('./lib/velocity.min');

_ = require('./lib/lodash.min');

easeljs = require('easeljs');

preloadjs = require('preloadjs');

_ua = navigator.userAgent;

_sp = _ua.indexOf('iPhone') > -1 || _ua.indexOf('iPod') > -1 || _ua.indexOf('Android') > -1;

if (_sp) {
  _device = 'sp';
} else {
  _device = 'pc';
}

ReplaceImg = (function() {
  function ReplaceImg($target1, func1) {
    var _this;
    this.$target = $target1;
    this.func = func1;
    _this = this;
    if (!_sp) {
      this.device = "pc";
    } else {
      this.device = "sp";
    }
    this.$target.each(function(i) {
      if ($(this).data("src") != null) {
        if (($(this).data("device") == null) || $(this).data("device") === _this.device) {
          $(this).attr("src", $(this).data("src").replace("device", _this.device));
        }
      }
      if (i === _this.$target.length - 1) {
        if (_this.func != null) {
          return _this.func();
        }
      }
    });
  }

  return ReplaceImg;

})();

Loading = (function() {
  function Loading() {
    this.scroll = bind(this.scroll, this);
    this.animate = bind(this.animate, this);
    this.end = bind(this.end, this);
    this.start = bind(this.start, this);
    this.$lLoad = $('.l-load');
    this.$load = this.$lLoad.find('.load');
    this.$b = this.$load.find('.b');
    this.order = [0, 4, 6, 8, 7, 2, 3, 9, 5];
  }

  Loading.prototype.searchImgSrc = function($img) {
    var imgs;
    imgs = [];
    $img.each(function() {
      if ($(this).is('img')) {
        if ($(this).attr('src') != null) {
          return imgs.push($(this).attr('src'));
        }
      } else if ($(this).css('background-image') !== 'none') {
        return imgs.push($(this).css('background-image').replace(/(url\(|\)|")/g, ''));
      }
    });
    return imgs;
  };

  Loading.prototype.load = function(imgs, func) {
    var isLoad, loadQueue, manifest;
    if (imgs != null) {
      manifest = imgs;
      isLoad = false;
      loadQueue = new createjs.LoadQueue();
      loadQueue.addEventListener('complete', (function(_this) {
        return function() {
          if ((func != null) && !isLoad) {
            func();
            return isLoad = true;
          }
        };
      })(this));
      loadQueue.loadManifest(manifest);
      return setTimeout((function(_this) {
        return function() {
          if ((func != null) && !isLoad) {
            func();
            return isLoad = true;
          }
        };
      })(this), 10000);
    } else {
      if ((func != null) && !isLoad) {
        func();
        return isLoad = true;
      }
    }
  };

  Loading.prototype.start = function() {
    $(window).on('touchmove.noScroll', (function(_this) {
      return function(e) {
        return e.preventDefault();
      };
    })(this));
    $('body').css({
      'overflow': 'hidden'
    });
    return this.animate();
  };

  Loading.prototype.end = function(func) {
    $(window).off('.noScroll');
    $('body').css({
      'overflow': 'visible'
    });
    this.scroll();
    return this.$lLoad.velocity({
      'opacity': 0
    }, {
      duration: 750,
      easing: 'easeOutCubic',
      delay: 500,
      complete: (function(_this) {
        return function() {
          _this.$lLoad.css({
            'display': 'none'
          });
          if (func != null) {
            return func();
          }
        };
      })(this)
    });
  };

  Loading.prototype.animate = function() {
    var _this;
    _this = this;
    this.$b.velocity({
      'opacity': 0,
      'scale': 1.75
    }, 0);
    return setTimeout((function(_this) {
      return function() {
        var i, j;
        i = 0;
        _this.$b.each(function() {
          $(this).velocity({
            'opacity': 1,
            'scale': 1
          }, {
            duration: 500,
            easing: 'easeInOutQuart',
            delay: 50 * _this.order[i]
          });
          return i++;
        });
        j = 0;
        setTimeout(function() {
          return _this.$b.each(function() {
            $(this).velocity({
              'opacity': 0,
              'scale': 1.375
            }, {
              duration: 500,
              easing: 'easeInOutQuart',
              delay: 50 * _this.order[j]
            });
            return j++;
          });
        }, 500 + 50 * 9 + 250);
        return setTimeout(function() {
          return _this.animate();
        }, (500 + 50 * 9) * 2);
      };
    })(this), 250);
  };

  Loading.prototype.scroll = function() {
    var hash;
    hash = location.hash;
    return setTimeout((function(_this) {
      return function() {
        if (location.hash !== '') {
          location.hash = '';
          return location.hash = hash;
        } else {
          return $('html, body').scrollTop(0);
        }
      };
    })(this), 500);
  };

  return Loading;

})();

Accordion = (function() {
  function Accordion($obj, $btn) {
    this.onClick = bind(this.onClick, this);
    this.setHeight = bind(this.setHeight, this);
    this.$obj = $obj;
    this.$btn = $btn;
    this.h = 0;
    this.isAnimate = false;
    this.setHeight();
    this.onClick();
  }

  Accordion.prototype.setHeight = function() {
    this.$obj.css({
      'display': 'block',
      'opacity': 0
    });
    return setTimeout((function(_this) {
      return function() {
        _this.h = _this.$obj.height();
        return _this.$obj.css({
          'height': 0,
          'opacity': 1
        });
      };
    })(this), 250);
  };

  Accordion.prototype.onClick = function() {
    return this.$btn.on('click', (function(_this) {
      return function() {
        if (!_this.isAnimate) {
          _this.isAnimate = true;
          if (!_this.$obj.hasClass('is-enable')) {
            _this.$obj.addClass('is-enable');
            _this.$obj.velocity({
              'height': _this.h
            }, 500, 'easeInOutCubic', function() {
              return _this.isAnimate = false;
            });
            _this.$btn.find('a').text('CLOSE');
          } else {
            _this.$obj.removeClass('is-enable');
            _this.$obj.velocity({
              'height': 0
            }, 500, 'easeInOutCubic', function() {
              return _this.isAnimate = false;
            });
            _this.$btn.find('a').text('MORE');
          }
        }
        return false;
      };
    })(this));
  };

  return Accordion;

})();

Modal = (function() {
  function Modal() {
    this.checkMove = bind(this.checkMove, this);
    this.onNext = bind(this.onNext, this);
    this.onPrev = bind(this.onPrev, this);
    this.onClose = bind(this.onClose, this);
    this.onClick = bind(this.onClick, this);
    this.enable = bind(this.enable, this);
    this.$modal = $('.l-modal');
    this.$inner = this.$modal.find('.inner');
    this.$bg = this.$modal.find('.bg');
    this.$item = this.$inner.find('.item');
    this.$close = this.$inner.find('.close');
    this.$prev = this.$inner.find('.prev');
    this.$next = this.$inner.find('.next');
    this.$modalLink = $('.m-modal_link');
    this.pt = parseInt(this.$inner.css('padding-top'));
    this.onClick();
    this.onClose();
    this.onPrev();
    this.onNext();
  }

  Modal.prototype.enable = function(id) {
    this.$item.filter("#" + id).addClass('is-enable');
    this.$modal.css({
      'opacity': 0,
      'display': 'block'
    }).velocity({
      'opacity': 1
    }, 250, 'easeOutCubic');
    this.$inner.css({
      'top': $(window).scrollTop() + $(window).height() / 2 - this.$inner.innerHeight() / 2 - this.pt
    });
    return this.checkMove();
  };

  Modal.prototype.onClick = function() {
    var _this;
    _this = this;
    return this.$modalLink.each(function() {
      return $(this).on('click', function() {
        _this.enable($(this).data('modal'));
        return false;
      });
    });
  };

  Modal.prototype.onClose = function() {
    var $target;
    $target = this.$bg.add(this.$close);
    return $target.on('click', (function(_this) {
      return function() {
        var $current;
        $current = _this.$item.filter('.is-enable');
        _this.$modal.velocity({
          'opacity': 0
        }, 500, 'easeOutCubic', function() {
          $current.removeClass('is-enable');
          return _this.$modal.css({
            'display': 'none'
          });
        });
        if ($current.find('iframe')[0] != null) {
          return $current.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + "stopVideo" + '","args":""}', '*');
        }
      };
    })(this));
  };

  Modal.prototype.onPrev = function() {
    return this.$prev.on('click', (function(_this) {
      return function() {
        var $current, $prev;
        $current = _this.$item.filter('.is-enable');
        $prev = $current.prev();
        $current.removeClass('is-enable');
        $prev.addClass('is-enable');
        if ($current.find('iframe')[0] != null) {
          $current.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + "stopVideo" + '","args":""}', '*');
        }
        _this.checkMove();
        return false;
      };
    })(this));
  };

  Modal.prototype.onNext = function() {
    return this.$next.on('click', (function(_this) {
      return function() {
        var $current, $next;
        $current = _this.$item.filter('.is-enable');
        $next = $current.next();
        $current.removeClass('is-enable');
        $next.addClass('is-enable');
        if ($current.find('iframe')[0] != null) {
          $current.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + "stopVideo" + '","args":""}', '*');
        }
        _this.checkMove();
        return false;
      };
    })(this));
  };

  Modal.prototype.checkMove = function() {
    var $current;
    this.$prev.removeClass('is-disable');
    this.$next.removeClass('is-disable');
    $current = this.$item.filter('.is-enable');
    if ($current.prev().length === 0) {
      this.$prev.addClass('is-disable');
    }
    if ($current.next().length === 0) {
      return this.$next.addClass('is-disable');
    }
  };

  return Modal;

})();

Video = (function() {
  function Video($canvas, src, width, height) {
    this.play = bind(this.play, this);
    var canvas, data, spriteSheet;
    canvas = $canvas.get(0);
    this.stage = new createjs.Stage(canvas);
    $(canvas).attr('width', width);
    $(canvas).attr('height', height);
    data = {
      images: src,
      frames: {
        width: width,
        height: height,
        regX: 0,
        regY: 0
      },
      animations: {
        framerate: 24
      }
    };
    spriteSheet = new createjs.SpriteSheet(data);
    this.sprite = new createjs.Sprite(spriteSheet);
    this.sprite.x = 0;
    this.sprite.y = 0;
    this.stage.addChild(this.sprite);
  }

  Video.prototype.play = function() {
    this.sprite.gotoAndPlay();
    this.stage.update();
    createjs.Ticker.setFPS(24);
    return createjs.Ticker.addEventListener('tick', this.stage);
  };

  return Video;

})();

CarouselBanner = (function() {
  function CarouselBanner() {
    this.onNext = bind(this.onNext, this);
    this.onPrev = bind(this.onPrev, this);
    this.orderList = bind(this.orderList, this);
    this.init = bind(this.init, this);
    this.$lBanner = $('.l-banner');
    this.$list = this.$lBanner.find('.list');
    this.$li = this.$list.find('li');
    this.$prev = this.$lBanner.find('.prev');
    this.$next = this.$lBanner.find('.next');
    this.len = this.$li.length;
    this.current = 0;
    this.pos = 0;
    this.w = this.$li.width();
    this.m = parseInt(this.$li.css('margin-right'));
    this.d = 500;
    this.isAnim = false;
    this.init();
  }

  CarouselBanner.prototype.init = function() {
    var i, k, ref;
    if (this.len > 3) {
      this.orderList();
      this.onPrev();
      return this.onNext();
    } else {
      for (i = k = 0, ref = this.len; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
        this.$li.eq(i).css({
          'left': (this.w + this.m) * i + ((this.w + this.m) * (3 - this.len))
        });
      }
      this.$prev.remove();
      return this.$next.remove();
    }
  };

  CarouselBanner.prototype.orderList = function() {
    var i, k, order, ref, results;
    results = [];
    for (i = k = 0, ref = this.len; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
      order = i - this.current;
      if (order >= this.len - 1) {
        order = -1;
      }
      if (order <= -2) {
        order = order + this.len;
      }
      results.push(this.$li.eq(i).css({
        'left': (this.w + this.m) * order + (this.w + this.m) * this.pos
      }));
    }
    return results;
  };

  CarouselBanner.prototype.onPrev = function() {
    return this.$next.on('click', (function(_this) {
      return function() {
        var prev;
        if (!_this.isAnim) {
          _this.isAnim = true;
          prev = _this.current + 3;
          if (prev > _this.len - 1) {
            prev = prev - _this.len;
          }
          _this.$li.eq(prev).css({
            'left': (_this.w + _this.m) * 3 + (_this.w + _this.m) * _this.pos
          });
          if (_this.current < _this.len - 1) {
            _this.current++;
          } else {
            _this.current = 0;
          }
          _this.pos++;
          _this.$list.velocity({
            'translateX': "-=" + (_this.w + _this.m)
          }, _this.d, 'easeOutCubic', function() {
            _this.orderList();
            return _this.isAnim = false;
          });
        }
        return false;
      };
    })(this));
  };

  CarouselBanner.prototype.onNext = function() {
    return this.$prev.on('click', (function(_this) {
      return function() {
        if (!_this.isAnim) {
          _this.isAnim = true;
          if (_this.current === 0) {
            _this.current = _this.len - 1;
          } else {
            _this.current--;
          }
          _this.pos--;
          _this.$list.velocity({
            'translateX': "+=" + (_this.w + _this.m)
          }, _this.d, 'easeOutCubic', function() {
            _this.orderList();
            return _this.isAnim = false;
          });
        }
        return false;
      };
    })(this));
  };

  return CarouselBanner;

})();

CarouselMovie = (function() {
  function CarouselMovie() {
    this.resize = bind(this.resize, this);
    this.onNext = bind(this.onNext, this);
    this.onPrev = bind(this.onPrev, this);
    this.anim = bind(this.anim, this);
    this.orderList = bind(this.orderList, this);
    this.$lMovie = $('.l-movie');
    this.$list = this.$lMovie.find('.list');
    this.$li = this.$list.find('li');
    this.$youtube = this.$li.find('iframe');
    this.$prev = this.$lMovie.find('.prev');
    this.$next = this.$lMovie.find('.next');
    this.len = this.$li.length;
    this.current = 0;
    this.pos = 0;
    this.w = !_sp ? this.$li.width() : $(window).width() - parseInt(this.$li.css('margin-right')) * 2 - parseInt(this.$li.css('padding-right')) * 2;
    this.m = parseInt(this.$li.css('margin-right'));
    this.d = 500;
    this.isAnim = false;
    this.orderList();
    this.onPrev();
    this.onNext();
    if (_sp) {
      this.resize();
    }
  }

  CarouselMovie.prototype.orderList = function() {
    var i, k, order, ref, results;
    results = [];
    for (i = k = 0, ref = this.len; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
      order = i - this.current;
      if (order >= this.len - 1) {
        order = -1;
      }
      if (order <= -2) {
        order = order + this.len;
      }
      results.push(this.$li.eq(i).css({
        'left': (this.w + this.m) * order + (this.w + this.m) * this.pos
      }));
    }
    return results;
  };

  CarouselMovie.prototype.anim = function() {
    this.$li.filter('.is-enable').velocity({
      'opacity': 0.2
    }, this.d, 'easeOutCubic', function() {
      return $(this).removeClass('is-enable');
    });
    return this.$li.eq(this.current).velocity({
      'opacity': 1
    }, this.d, 'easeOutCubic', function() {
      return $(this).addClass('is-enable');
    });
  };

  CarouselMovie.prototype.onPrev = function() {
    return this.$next.on('click', (function(_this) {
      return function() {
        var $youtube;
        if (!_this.isAnim) {
          _this.isAnim = true;
          if (_this.current < _this.len - 1) {
            _this.current++;
          } else {
            _this.current = 0;
          }
          _this.pos++;
          _this.anim();
          _this.$list.velocity({
            'translateX': "-=" + (_this.w + _this.m)
          }, _this.d, 'easeOutCubic', function() {
            _this.orderList();
            return _this.isAnim = false;
          });
          $youtube = _this.$li.filter('.is-enable').find('iframe')[0];
          if ($youtube != null) {
            $youtube.contentWindow.postMessage('{"event":"command","func":"' + "stopVideo" + '","args":""}', '*');
          }
        }
        return false;
      };
    })(this));
  };

  CarouselMovie.prototype.onNext = function() {
    return this.$prev.on('click', (function(_this) {
      return function() {
        var $youtube, next;
        if (!_this.isAnim) {
          _this.isAnim = true;
          next = _this.current + 2;
          if (next > _this.len - 1) {
            next = next - _this.len;
          }
          _this.$li.eq(next).css({
            'left': -(_this.w + _this.m) * 2 + (_this.w + _this.m) * _this.pos
          });
          if (_this.current === 0) {
            _this.current = _this.len - 1;
          } else {
            _this.current--;
          }
          _this.pos--;
          _this.anim();
          _this.$list.velocity({
            'translateX': "+=" + (_this.w + _this.m)
          }, _this.d, 'easeOutCubic', function() {
            _this.orderList();
            return _this.isAnim = false;
          });
          $youtube = _this.$li.filter('.is-enable').find('iframe')[0];
          if ($youtube != null) {
            $youtube.contentWindow.postMessage('{"event":"command","func":"' + "stopVideo" + '","args":""}', '*');
          }
          return false;
        }
      };
    })(this));
  };

  CarouselMovie.prototype.resize = function() {
    var h, w;
    w = this.w;
    h = w * 0.5625;
    this.$list.css({
      'margin-left': -w * 0.5
    });
    this.$youtube.attr('width', w);
    this.$youtube.attr('height', h);
    this.$prev.css({
      'height': h,
      'line-height': h + 'px'
    });
    this.$next.css({
      'height': h,
      'line-height': h + 'px'
    });
    this.$li.css({
      'width': w,
      'height': h
    });
    return this.$lMovie.css({
      'height': h
    });
  };

  return CarouselMovie;

})();

CarouselCharacter = (function() {
  function CarouselCharacter() {
    this.onTouch = bind(this.onTouch, this);
    this.init = bind(this.init, this);
    this.$lCharacter = $('.l-character');
    this.$illust = this.$lCharacter.find('.illust');
    this.$illustList = this.$illust.find('.list');
    this.$illustListLi = this.$illustList.find('li');
    this.$profile = this.$lCharacter.find('.profile');
    this.$profileList = this.$profile.find('.list');
    this.$profileListLi = this.$profileList.find('li');
    this.total = this.$illustList.find('li').length;
    this.page = 1;
    this.width = $(window).width() / 2;
    this.startX = 0;
    this.endX = 0;
    this.startY = 0;
    this.endY = 0;
    this.diff = 0;
    this.move = 0;
    this.x = -$(window).width() / 2;
    this.isFlick = false;
    this.isAnim = false;
    this.init();
    this.onTouch();
  }

  CarouselCharacter.prototype.init = function() {
    return this.$illustList.css({
      'transform': "translateX(-" + this.width + "px)"
    });
  };

  CarouselCharacter.prototype.onTouch = function() {
    return this.$illustList.on('touchstart', (function(_this) {
      return function(e) {
        _this.startX = event.changedTouches[0].pageX;
        return _this.startY = event.changedTouches[0].pageY;
      };
    })(this)).on('touchmove', (function(_this) {
      return function(e) {
        _this.endX = event.changedTouches[0].pageX;
        _this.endY = event.changedTouches[0].pageY;
        if (Math.abs(_this.startX - _this.endX) > 5 && Math.abs(_this.startY - _this.endY) < 10) {
          _this.isFlick = true;
        }
        if (_this.isFlick) {
          e.preventDefault();
          _this.diff = Math.round(_this.startX - _this.endX);
          _this.move = _this.x - _this.diff;
          if (_this.move > 0 && _this.x <= 0) {
            _this.move = 0;
          } else if (_this.move < -_this.width * (_this.total - 1)) {
            _this.move = -_this.width * (_this.total - 1);
          }
          return _this.$illustList.css({
            'transform': "translateX(" + _this.move + "px)"
          });
        }
      };
    })(this)).on('touchend', (function(_this) {
      return function(e) {
        var page;
        if (_this.isFlick) {
          _this.x = _this.move;
          page = _this.page;
          if (_this.diff > 0) {
            if (-_this.x >= _this.width * _this.page + _this.width * 0.25) {
              _this.page++;
            }
          } else {
            if (-_this.x <= _this.width * _this.page - _this.width * 0.25) {
              _this.page--;
            }
          }
          if (page !== _this.page) {
            _this.$currentIllust = _this.$illustListLi.filter('.is-active');
            _this.$nextIllust = _this.$illustListLi.eq(_this.page - 1);
            _this.$currentProfile = _this.$profileListLi.filter('.is-active');
            _this.$nextProfile = _this.$profileListLi.eq(_this.page - 1);
            _this.$currentIllust.velocity({
              'opacity': 0.2
            }, 500, 'easeOutCubic');
            _this.$nextIllust.velocity({
              'opacity': 1
            }, 500, 'easeOutCubic', function() {
              _this.$illustListLi.removeClass('is-active');
              return _this.$nextIllust.addClass('is-active');
            });
            _this.$currentProfile.velocity({
              'opacity': 0
            }, 250, 'easeOutCubic');
            _this.$nextProfile.velocity({
              'opacity': 1
            }, 500, 'easeInCubic', function() {
              _this.$profileListLi.removeClass('is-active');
              return _this.$nextProfile.addClass('is-active');
            });
          }
          return _this.$illustList.velocity('finish').velocity({
            'translateX': _this.move
          }, 1, 'linear', function() {
            _this.$illustList.velocity({
              'translateX': -_this.width * _this.page
            }, 500, 'easeOutCubic', function() {
              return _this.isFlick = false;
            });
            return _this.x = -_this.width * _this.page;
          });
        }
      };
    })(this));
  };

  return CarouselCharacter;

})();

ReplaceYoutube = (function() {
  function ReplaceYoutube() {
    this.onPlay = bind(this.onPlay, this);
    this.replace = bind(this.replace, this);
    this.movie = [];
    this.w = [];
    this.h = [];
    this.img = [];
    this.replace();
    this.onPlay();
  }

  ReplaceYoutube.prototype.replace = function() {
    var _this;
    _this = this;
    return $('.m-youtube').each(function(i, elem) {
      var h, src, w;
      src = $(this).data('src');
      w = $(this).data('width');
      h = $(this).data('height');
      _this.movie[i] = src;
      _this.w[i] = w;
      _this.h[i] = h;
      _this.img[i] = 'http://i.ytimg.com/vi' + src.substring(src.lastIndexOf("/"), src.lastIndexOf("?")) + '/maxresdefault.jpg';
      return $(this).append("<div class='play'><img src='" + _this.img[i] + "' width='" + _this.w[i] + "'><div class='btn'></div></div>");
    });
  };

  ReplaceYoutube.prototype.onPlay = function() {
    var _this;
    _this = this;
    return $('.play').each(function(i, elem) {
      return $(this).on('click', function() {
        var $iframe;
        $(this).after("<div class='youtube'><iframe src='" + _this.movie[i] + "&amp;autoplay=1' width='" + _this.w[i] + "' height='" + _this.h[i] + "' frameborder='0'></iframe></div>");
        $iframe = $(this).next().find('iframe')[0];
        $(this).remove();
        if (_sp) {
          return setTimeout((function(_this) {
            return function() {
              return $iframe.contentWindow.postMessage('{"event":"command","func":"' + "playVideo" + '","args":""}', '*');
            };
          })(this), 500);
        }
      });
    });
  };

  return ReplaceYoutube;

})();

AnimateIndex = (function() {
  function AnimateIndex() {
    this.finish = bind(this.finish, this);
    this.playMovie = bind(this.playMovie, this);
    this.slotText = bind(this.slotText, this);
    this.title = bind(this.title, this);
    this.animate = bind(this.animate, this);
    this.$lLoad = $('.l-load');
    this.$lHeader = $('.l-header');
    this.$lVisual = $('.l-visual');
    this.$title = this.$lVisual.find('.title');
    this.$copy = this.$title.find('.copy');
    this.$copyImg = this.$copy.find('img');
    this.$logo = this.$title.find('.logo');
    this.$bg = this.$lVisual.find('.bg');
    if (!_sp) {
      this.$video = this.$bg.find('video')[0];
    }
    this.$information = this.$lVisual.find('.information');
    this.$lNews = $('.l-news');
    this.$lBanner = $('.l-banner');
    this.$lContents = $('.l-contents');
    this.$lFooter = $('.l-footer');
    this.copyH = this.$copy.height();
    if (_sp) {
      this.video = new Video(this.$bg.find('canvas'), ['/assets/images/sp/index/bg_visual_1.jpg', '/assets/images/sp/index/bg_visual_2.jpg', '/assets/images/sp/index/bg_visual_3.jpg', '/assets/images/sp/index/bg_visual_4.jpg', '/assets/images/sp/index/bg_visual_5.jpg'], 320, 568);
    }
    this.init();
  }

  AnimateIndex.prototype.init = function() {
    this.$lContents.css({
      'display': 'none'
    });
    this.$lFooter.css({
      'display': 'none'
    });
    this.$lHeader.css({
      'display': 'none'
    });
    this.$copy.css({
      'opacity': 0
    });
    this.$logo.css({
      'opacity': 0
    });
    this.$title.velocity({
      'scale': 1.1
    }, 0);
    this.$bg.css({
      'opacity': 0
    });
    this.$information.css({
      'display': 'none'
    });
    if (!_sp) {
      this.$lNews.css({
        'display': 'none'
      });
      this.$lBanner.css({
        'display': 'none'
      });
      return this.$video.addEventListener('play', (function(_this) {
        return function() {
          setTimeout(function() {
            return _this.$video.pause();
          }, 500);
          return _this.$video.removeEventListener('play', arguments.callee, false);
        };
      })(this));
    }
  };

  AnimateIndex.prototype.animate = function(func) {
    return setTimeout((function(_this) {
      return function() {
        _this.title();
        return setTimeout(function() {
          return _this.slotText(function() {
            _this.playMovie();
            return setTimeout(function() {
              _this.finish();
              _this.$lContents.css({
                'display': 'block'
              });
              _this.$lFooter.css({
                'display': 'block'
              });
              return func();
            }, 1500);
          });
        }, 1000);
      };
    })(this), 375);
  };

  AnimateIndex.prototype.title = function() {
    this.$title.velocity({
      'scale': 1
    }, 4250, 'linear');
    return this.$logo.velocity({
      'opacity': 1
    }, 1000, 'easeOutSine');
  };

  AnimateIndex.prototype.slotText = function(callback) {
    var i, timerId;
    this.$copy.css({
      'opacity': 1
    });
    i = 0;
    return timerId = setInterval((function(_this) {
      return function() {
        if (i < 35) {
          i++;
          return _this.$copyImg.css({
            'top': -_this.copyH * i
          });
        } else {
          clearInterval(timerId);
          return callback();
        }
      };
    })(this), 37.5);
  };

  AnimateIndex.prototype.playMovie = function() {
    if (!_sp) {
      this.$video.play();
    } else {
      this.video.play();
    }
    return this.$bg.velocity({
      'opacity': 0.9
    }, {
      duration: 750,
      easing: 'linear',
      delay: 250
    });
  };

  AnimateIndex.prototype.finish = function() {
    this.$lHeader.css({
      'opacity': 0,
      'display': 'block'
    }).velocity({
      'opacity': 1
    }, 1000, 'easeOutCubic');
    this.$information.css({
      'opacity': 0,
      'display': 'block'
    }).velocity({
      'opacity': 1
    }, 1000, 'easeOutCubic');
    if (!_sp) {
      this.$lNews.css({
        'opacity': 0,
        'display': 'block'
      }).velocity({
        'opacity': 1
      }, 1000, 'easeOutCubic');
      return this.$lBanner.css({
        'opacity': 0,
        'display': 'block'
      }).velocity({
        'opacity': 1
      }, 1000, 'easeOutCubic');
    }
  };

  return AnimateIndex;

})();

AnimateTitle = (function() {
  function AnimateTitle() {
    this.animateJa = bind(this.animateJa, this);
    this.animateEn = bind(this.animateEn, this);
    this.animate = bind(this.animate, this);
    this.init = bind(this.init, this);
    this.$lTitle = $('.l-title');
    this.$title = this.$lTitle.find('.title');
    this.$en = this.$title.find('.en');
    this.$ja = this.$title.find('.ja');
    this.en = this.$en.text().split('');
    this.jaW = 0;
    this.init();
  }

  AnimateTitle.prototype.init = function() {
    this.$en.css({
      'opacity': 0
    });
    setTimeout((function(_this) {
      return function() {
        _this.$en.css({
          'width': _this.$en.width(),
          'opacity': 1
        });
        return _this.$en.text('');
      };
    })(this), 374);
    this.jaW = this.$ja.width() + 2;
    this.jaH = this.$ja.height() + 2;
    this.$ja.wrapInner('<div class="inner"></div>');
    this.$ja.css({
      'width': 0,
      'height': this.jaH,
      'overflow': 'hidden',
      'left': !_sp ? 960 - this.jaW : $(window).width() - 24 - this.jaW / 2,
      'padding-left': 0,
      'padding-right': 0
    });
    return this.$ja.find('.inner').css({
      'width': this.jaW,
      'position': 'absolute',
      'top': 1,
      'left': 1
    });
  };

  AnimateTitle.prototype.animate = function() {
    return this.animateEn((function(_this) {
      return function() {
        return _this.animateJa();
      };
    })(this));
  };

  AnimateTitle.prototype.animateEn = function(callback) {
    var alphabet, i, j, str, timerId;
    alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    str = '';
    i = 0;
    j = 0;
    return timerId = setInterval((function(_this) {
      return function() {
        if (j < _this.en.length) {
          if (i < 4) {
            _this.$en.text(str + alphabet[Math.floor(Math.random() * alphabet.length)]);
            return i++;
          } else {
            str = str + _this.en[j];
            _this.$en.text(str);
            i = 0;
            return j++;
          }
        } else {
          clearInterval(timerId);
          return callback();
        }
      };
    })(this), 12);
  };

  AnimateTitle.prototype.animateJa = function() {
    return this.$ja.velocity({
      'width': this.jaW
    }, {
      duration: 500,
      easing: 'easeInOutExpo',
      mobileHA: false
    });
  };

  return AnimateTitle;

})();

Header = (function() {
  function Header() {
    this.nav = bind(this.nav, this);
    this.changeColor = bind(this.changeColor, this);
    this.$lHeader = $('.l-header');
    this.$lTitle = $('.l-title');
    if (!$('body').hasClass('index')) {
      this.changeColor();
    }
    if (_sp) {
      this.nav();
    }
  }

  Header.prototype.changeColor = function() {
    var t;
    t = this.$lTitle.height() - this.$lHeader.height();
    return $(window).on('scroll', (function(_this) {
      return function() {
        if ($(window).scrollTop() > t) {
          if (!_this.$lHeader.hasClass('is-white')) {
            return _this.$lHeader.addClass('is-white');
          }
        } else {
          if (_this.$lHeader.hasClass('is-white')) {
            return _this.$lHeader.removeClass('is-white');
          }
        }
      };
    })(this));
  };

  Header.prototype.nav = function() {
    var $bg, $btn, $li, $list, $nav, isAnim;
    $nav = this.$lHeader.find('.nav');
    $btn = $nav.find('.btn');
    $list = $nav.find('.list');
    $li = $list.find('.li');
    $bg = $nav.find('.bg');
    isAnim = false;
    $list.velocity({
      'opacity': 0,
      'scale': 1.125
    }, 0);
    return $btn.on('touchstart', (function(_this) {
      return function() {
        if ($nav.hasClass('is-disable')) {
          if (!isAnim) {
            isAnim = true;
            $nav.removeClass('is-disable');
            $nav.addClass('is-enable');
            $bg.css({
              'display': 'block'
            });
            return $list.css({
              'display': 'block'
            }).velocity({
              'opacity': 1,
              'scale': 1
            }, 500, 'easeOutQuart', function() {
              return isAnim = false;
            });
          }
        } else {
          if (!isAnim) {
            isAnim = true;
            $nav.removeClass('is-enable');
            $nav.addClass('is-disable');
            $bg.css({
              'display': 'none'
            });
            return $list.velocity({
              'opacity': 0,
              'scale': 1.25
            }, 250, 'easeOutCubic', function() {
              isAnim = false;
              return $list.css({
                'display': 'none'
              }).velocity({
                'scale': 1.125
              }, 0);
            });
          }
        }
      };
    })(this));
  };

  return Header;

})();

Footer = (function() {
  function Footer() {
    this.alignDefintionList = bind(this.alignDefintionList, this);
    this.$lFooter = $('.l-footer');
    this.$detail = this.$lFooter.find('.detail');
    this.$devices = this.$detail.find('.devices');
    this.$information = this.$detail.find('.information');
    this.$sp = this.$detail.find('.sp');
    this.$pc = this.$detail.find('.pc');
    this.$spEnvironment = this.$sp.find('.environment');
    this.$spBtn = this.$sp.find('.btn');
    this.$pcEnvironment = this.$pc.find('.environment');
    this.$pcBtn = this.$pc.find('.btn');
    new Accordion(this.$spEnvironment, this.$spBtn);
    new Accordion(this.$pcEnvironment, this.$pcBtn);
    this.alignDefintionList();
  }

  Footer.prototype.alignDefintionList = function() {
    var h;
    this.$information.each(function() {
      var w;
      w = 0;
      $(this).find('dt').each(function() {
        if ($(this).width() > w) {
          return w = $(this).width();
        }
      });
      $(this).find('dt').css({
        'width': w + 8
      });
      return $(this).find('dd').css({
        'margin-left': w + 8
      });
    });
    if (!_sp) {
      h = 0;
      this.$devices.each(function() {
        if ($(this).height() > h) {
          return h = $(this).height();
        }
      });
      return this.$devices.css({
        'height': h
      });
    }
  };

  return Footer;

})();

Index = (function() {
  function Index() {
    this.load = bind(this.load, this);
    this.replaceTwitter = bind(this.replaceTwitter, this);
    this.getYoutube = bind(this.getYoutube, this);
    this.getBanner = bind(this.getBanner, this);
    this.getNews = bind(this.getNews, this);
    this.initVisual = bind(this.initVisual, this);
    this.$lVisual = $('.l-visual');
    this.$lNews = $('.l-news');
    this.$lBanner = $('.l-banner');
    this.$bannerList = this.$lBanner.find('.list');
    this.$lMovie = $('.l-movie');
    this.$movieList = this.$lMovie.find('.list');
    this.$lSystem = $('.l-system');
    this.$lTwitter = $('.l-twitter');
    this.initVisual();
    this.animateIndex = new AnimateIndex;
    this.loading = new Loading;
    if (_sp) {
      new CarouselCharacter();
    }
    this.getNews();
    this.getBanner();
    this.getYoutube();
    this.load();
  }

  Index.prototype.initVisual = function() {
    $(window).resize((function(_this) {
      return function() {
        return _this.$lVisual.css({
          'height': $(window).height()
        });
      };
    })(this));
    $(window).resize();
    if (!_sp) {
      return this.$lVisual.find('.bg .sp').remove();
    } else {
      this.$lVisual.find('.bg .pc').remove();
      return this.$lSystem.find('.bg .pc').remove();
    }
  };

  Index.prototype.getNews = function() {
    return $.getJSON('/data/news.json', (function(_this) {
      return function(data) {
        _this.$lNews.find('.date span').html(data[0].date);
        return _this.$lNews.find('.title a').html(data[0].title);
      };
    })(this));
  };

  Index.prototype.getBanner = function() {
    return $.getJSON('/data/banner.json', (function(_this) {
      return function(data) {
        var blank, i, k, len, val;
        for (i = k = 0, len = data.length; k < len; i = ++k) {
          val = data[i];
          if (data[i].blank) {
            blank = "target='_blank'";
          } else {
            blank = "";
          }
          _this.$bannerList.append("<li><a href='" + data[i].href + "' " + blank + "><img src='" + data[i].image + "' alt=''></a></li>");
        }
        if (!_sp) {
          return new CarouselBanner();
        }
      };
    })(this));
  };

  Index.prototype.getYoutube = function() {
    return $.getJSON('/data/youtube.json', (function(_this) {
      return function(data) {
        var i, k, len, val;
        for (i = k = 0, len = data.length; k < len; i = ++k) {
          val = data[i];
          _this.$movieList.append("<li><div class='m-youtube' data-src='https://www.youtube.com/embed/" + data[i] + "?rel=0&amp;showinfo=0&amp;enablejsapi=1' data-width='640' data-height='360'></div></li>");
        }
        _this.$movieList.find('li').eq(0).addClass('is-enable');
        new CarouselMovie;
        return new ReplaceYoutube();
      };
    })(this));
  };

  Index.prototype.replaceTwitter = function() {
    return this.$lTwitter.find('.twitter').append('<a class="twitter-timeline" data-lang="ja" data-width="100%" data-height="360" data-theme="dark" href="https://twitter.com/monotosituation">Tweets by monotosituation</a><script async src="//platform.twitter.com/widgets.js" charset="utf-8"</script>');
  };

  Index.prototype.load = function() {
    return new ReplaceImg($('img'), (function(_this) {
      return function() {
        var imgs;
        imgs = _this.loading.searchImgSrc($('*'));
        if (!_sp) {
          imgs.push = "/assets/images/pc/index/bg_visual.mp4";
        } else {
          imgs.push = "/assets/images/sp/index/bg_visual_1.jpg";
          imgs.push = "/assets/images/sp/index/bg_visual_2.jpg";
          imgs.push = "/assets/images/sp/index/bg_visual_3.jpg";
          imgs.push = "/assets/images/sp/index/bg_visual_4.jpg";
          imgs.push = "/assets/images/sp/index/bg_visual_5.jpg";
        }
        _this.loading.start();
        return _this.loading.load(imgs, function() {
          return _this.loading.end(function() {
            return _this.animateIndex.animate(function() {
              new Footer();
              return _this.replaceTwitter();
            });
          });
        });
      };
    })(this));
  };

  return Index;

})();

Character = (function() {
  function Character() {
    this.playVoice = bind(this.playVoice, this);
    this.$lContents = $('.l-contents');
    this.$voiceSamples = this.$lContents.find('.voice_samples');
    this.$voice = this.$voiceSamples.find('.voice');
    this.playVoice();
  }

  Character.prototype.playVoice = function() {
    return this.$voice.find('li').each(function() {
      var $audio;
      $audio = $(this).find('audio')[0];
      return $(this).find('a').on('click', (function(_this) {
        return function() {
          $('audio').each(function() {
            $(this)[0].pause();
            return $(this)[0].currentTime = 0;
          });
          $audio.play();
          return false;
        };
      })(this));
    });
  };

  return Character;

})();

Media = (function() {
  function Media() {
    this.getData = bind(this.getData, this);
    this.$lContents = $('.l-contents');
    this.$items = this.$lContents.find('.items');
    this.$lModal = $('.l-modal');
    this.$modalItems = this.$lModal.find('.items');
    this.$tplMediaPc = $('#tplMediaPc');
    this.$tplMediaSp = $('#tplMediaSp');
    this.$tplModal = $('#tplModal');
    this.getData();
  }

  Media.prototype.getData = function() {
    return $.getJSON('/data/media.json', (function(_this) {
      return function(data) {
        if (!_sp) {
          _this.$items.append(_.template(_this.$tplMediaPc.html())({
            "data": data
          }));
          _this.$modalItems.append(_.template(_this.$tplModal.html())({
            "data": data
          }));
          new ReplaceYoutube();
          return new Modal();
        } else {
          _this.$items.append(_.template(_this.$tplMediaSp.html())({
            "data": data
          }));
          return new ReplaceYoutube();
        }
      };
    })(this));
  };

  return Media;

})();

CastStaff = (function() {
  function CastStaff() {
    this.getData = bind(this.getData, this);
    this.$lContents = $('.l-contents');
    this.$tplCredits = $('#tplCredits');
    this.getData();
  }

  CastStaff.prototype.getData = function() {
    return $.getJSON('/data/credits.json', (function(_this) {
      return function(data) {
        return _this.$lContents.append(_.template(_this.$tplCredits.html())({
          "data": data
        }));
      };
    })(this));
  };

  return CastStaff;

})();

News = (function() {
  function News() {
    this.onAccoordion = bind(this.onAccoordion, this);
    this.getData = bind(this.getData, this);
    this.$lContents = $('.l-contents');
    this.$main = this.$lContents.find('.main');
    this.$sub = this.$lContents.find('.sub .list');
    this.$tplMain = $('#tplMain');
    this.$tplSub = $('#tplSub');
    this.getData();
  }

  News.prototype.getData = function() {
    return $.getJSON('/data/news.json', (function(_this) {
      return function(data) {
        _this.$main.append(_.template(_this.$tplMain.html())({
          "data": data
        }));
        _this.$sub.append(_.template(_this.$tplSub.html())({
          "data": data
        }));
        return _this.onAccoordion();
      };
    })(this));
  };

  News.prototype.onAccoordion = function() {
    var _this;
    _this = this;
    return $('.item').each(function() {
      var $btn, $description;
      $description = $(this).find('.description');
      $btn = $(this).find('.btn');
      return new Accordion($description, $btn);
    });
  };

  return News;

})();

$(function() {
  var $body, animateTitle, loading;
  $body = $('body');
  loading = new Loading;
  new Header();
  if ($('body').hasClass('index')) {
    new Index();
  } else {
    new Footer();
    animateTitle = new AnimateTitle;
    new ReplaceImg($('img'), (function(_this) {
      return function() {
        loading.start();
        return loading.load(loading.searchImgSrc($('*')), function() {
          return loading.end(function() {
            return animateTitle.animate();
          });
        });
      };
    })(this));
  }
  if ($('body').hasClass('character')) {
    new Character();
  }
  if ($('body').hasClass('system')) {
    new ReplaceYoutube();
    if (!_sp) {
      new Modal();
    }
  }
  if ($('body').hasClass('media')) {
    new Media();
  }
  if ($('body').hasClass('cast_staff')) {
    new CastStaff();
  }
  if ($('body').hasClass('news')) {
    return new News();
  }
});

//# sourceMappingURL=data:application/json;base64,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
